<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>To Rosemary, with all the three A’s.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a1516f76